import { useSelector } from "react-redux";

export default function useAuthStudent() {
  const auth = useSelector((state) => state.auth);
  return auth?.accessToken && auth?.user && auth?.user?.role === "student"
    ? true
    : false;
}
